import copy from './copy.json';
import { validateEmail, validatePassword } from './nativeValidation';
export const translate = (locale, key, vars = {}) =>
  String(copy[locale === 'en' ? 'en' : 'ko'][key] || key).replace(
    /\{\{(\w+)\}\}/g,
    (_, k) => vars[k] ?? '',
  );
export function validateForm(mode, f, t) {
  const e = {};
  if (mode === 'forgot') {
    if (!validateEmail(f.email)) e.email = t('auth.validEmailRequired');
    return e;
  }
  if (mode === 'reset') {
    if (!f.token.trim()) return { submit: t('auth.resetTokenMissing') };
    if (!validatePassword(f.password)) return { submit: t('auth.passwordRule') };
    if (f.password !== f.confirm) return { submit: t('auth.passwordMismatch') };
    return e;
  }
  if (!f.current) e.current = t('auth.currentPasswordRequired');
  if (!validatePassword(f.password)) e.password = t('auth.passwordRule');
  if (f.current && f.current === f.password) e.password = t('auth.differentPasswordRequired');
  if (!f.confirm) e.confirm = t('auth.confirmNewPassword');
  else if (f.password !== f.confirm) e.confirm = t('auth.newPasswordMismatch');
  return e;
}
export function requestError(error, fallback) {
  const msg = error?.response?.data?.message;
  return typeof msg === 'string' && msg.trim() ? msg : fallback;
}
